/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.FormList";
        class FormListWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("FormListWidgetTypeClass.createInstance()");
                    return new FormListWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("FormListWidgetTypeClass._storeHtml()");
                    FormListWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("FormListWidgetTypeClass::constructor");
                if (FormListWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/FormList/form-list.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.FormListWidgetTypeClass = FormListWidgetTypeClass;
        class FormListWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._noRecords = null;
                this._loader = null;
                this._listHolder = null;
                this._filterText = null;
                this._showFilterSpan = null;
                this._hideFilterSpan = null;
                this._filterPanel = null;
                this._refreshButton = null;
                this._presentAsButtons = null;
                this._buttonsVertical = null;
                this._dataList = null;
                this._buttonPalette = null;
                this.presentInstance = () => {
                    this._log.info("FormListWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = FormListWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._noRecords = this._container.querySelector('#formListNoRecords');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._listHolder = this._container.querySelector('#formListHolder');
                    this._filterText = this._container.querySelector('#formListFilter');
                    this._showFilterSpan = this._container.querySelector('.formListShowFilter');
                    this._hideFilterSpan = this._container.querySelector('.formListCancelFilter');
                    this._filterPanel = this._container.querySelector('.widget__filter');
                    this._refreshButton = this._container.querySelector('#formListReload');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#formListWidgetTitle'), 'STR_WPT_FORMS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#formListNoRecordsMessage'), 'STR_WPT_NOINFO');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#formListLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'aria-label', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._refreshButton, 'title', 'STR_WPT_REFRESH');
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._showFilterSpan.addEventListener('click', this._showFilter);
                    this._hideFilterSpan.addEventListener('click', this._hideFilter);
                    this._refreshButton.addEventListener('click', this._loadFormData);
                    this._container.querySelector('.formListClearFilter').addEventListener('click', this._clearFilter);
                    if (this._presentAsButtons && !this._buttonsVertical) {
                        this._listHolder.classList.add('widget__body-item--no-padding');
                    }
                    if (this._presentAsButtons) {
                        let usePrimary = false;
                        if (this._config.hasOwnProperty('SuppressHeading') && this._config.SuppressHeading === true) {
                            usePrimary = true;
                        }
                        let bpConfig = {
                            Orientation: this._buttonsVertical ? 'Vertical' : 'Horizontal',
                            SuppressNoItemsBanner: true,
                            UsePrimaryColour: usePrimary
                        };
                        this._buttonPalette = new Widgets.ComponentButtonPalette(this._core, this._listHolder, this, bpConfig, this._formClicked);
                        this._buttonPalette.present();
                    }
                    else {
                        let listConfig = {
                            SelectItemCallback: this._formClicked
                        };
                        this._dataList = new Widgets.ComponentDataList(this._core, this._listHolder, this, listConfig);
                        this._dataList.present();
                    }
                    this._loadFormData();
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("FormListWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("FormListWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this.returnedToHomepage = () => {
                    this._log.info("FormListWidgetInstanceClass.returnedToHomepage()");
                    this._clearFormSelection();
                };
                this._loadFormData = () => {
                    this._log.info("FormListWidgetInstanceClass._loadFormData()");
                    this._hideFilter();
                    this._core.Functions.hideElement(this._noRecords);
                    this._core.Functions.showElement(this._loader);
                    this._core.Loader.genericServiceCall('/Forms.svc/rest/GetAllFormsList', this._formResponse, this._callErrorHandler, this._callFailedHandler);
                };
                this._formResponse = (formData) => {
                    this._log.info("FormListWidgetInstanceClass._formResponse()");
                    this._core.Functions.hideElement(this._loader);
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearDisplay();
                    }
                    else {
                        this._dataList.clearList();
                    }
                    let availableForms = [];
                    let availableNames = [];
                    if (formData.hasOwnProperty('Forms') && formData.Forms.length > 0) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got forms: " + formData.Forms.length);
                        }
                        let conf = this._config;
                        if (conf.hasOwnProperty('DocTypes') && conf.DocTypes.length > 0) {
                            if (conf.DocTypes[0] === '*') {
                                availableForms.push(...formData.Forms);
                                availableNames.push(...formData.Forms.map(form => this._core.OBHelper.getDocTypeAlias(form.Name, form.TranslatedName)));
                            }
                            else {
                                let formLength = formData.Forms.length;
                                let confLength = conf.DocTypes.length;
                                for (let d = 0; d < confLength; d++) {
                                    let doctype = conf.DocTypes[d];
                                    let docTypeName = null;
                                    let displayName = null;
                                    if (doctype.hasOwnProperty('DocType')) {
                                        let formEntry = doctype;
                                        docTypeName = formEntry.DocType;
                                        if (formEntry.hasOwnProperty('DisplayName') && formEntry.DisplayName.length > 0) {
                                            displayName = this._core.Locale.getTranslation(formEntry.DisplayName);
                                        }
                                    }
                                    else {
                                        docTypeName = doctype;
                                    }
                                    for (let f = 0; f < formLength; f++) {
                                        let form = formData.Forms[f];
                                        if (form.Name === docTypeName) {
                                            availableForms.push(form);
                                            availableNames.push(displayName != null ? displayName : this._core.OBHelper.getDocTypeAlias(form.Name, form.TranslatedName));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            availableForms.push(...formData.Forms);
                            availableNames.push(...formData.Forms.map(form => this._core.OBHelper.getDocTypeAlias(form.Name, form.TranslatedName)));
                        }
                    }
                    if (availableForms.length > 0) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got remaining forms: " + availableForms.length);
                        }
                        this._presentFormData(availableForms, availableNames);
                    }
                    else {
                        this._core.Functions.showElement(this._noRecords);
                    }
                };
                this._presentFormData = (forms, names) => {
                    this._log.info("FormListWidgetInstanceClass._presentFormData()");
                    let length = forms.length;
                    if (this._presentAsButtons) {
                        let buttonOptions = [];
                        for (let f = 0; f < length; f++) {
                            let form = forms[f];
                            let name = names[f];
                            let buttonOption = {
                                Identifier: form.Type + ":" + form.Name,
                                Label: name
                            };
                            buttonOptions.push(buttonOption);
                        }
                        this._buttonPalette.displayOptions(buttonOptions);
                    }
                    else {
                        let listData = {
                            Items: []
                        };
                        for (let f = 0; f < length; f++) {
                            let form = forms[f];
                            let name = names[f];
                            let itemData = {
                                Id: form.Type + ":" + form.Name,
                                DisplayName: name
                            };
                            listData.Items.push(itemData);
                        }
                        this._dataList.displayData(listData);
                    }
                };
                this._formClicked = (id) => {
                    this._log.info("FormListWidgetInstanceClass._formClicked()");
                    let config = this._config;
                    let splitPos = id.indexOf(":");
                    let formType = id.substring(0, splitPos);
                    let formName = id.substring(splitPos + 1);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("selected form '" + formName + "' with type: " + formType);
                    }
                    this._clearFormSelection();
                    if (this._presentAsButtons) {
                        this._buttonPalette.selectOption(id);
                    }
                    else {
                        this._dataList.selectItem(id);
                    }
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.FORM_SELECTED);
                    let formCtx = {
                        Form: formName,
                        Type: formType,
                        ReturnHome: true
                    };
                    if (config.hasOwnProperty('RecreateOnSubmit') && config.RecreateOnSubmit === true) {
                        formCtx.ReturnHome = false;
                    }
                    navEvent.PrimaryContext = formCtx;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "FormView";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._clearFormSelection = () => {
                    this._log.info("FormListWidgetInstanceClass._clearFormSelection()");
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearOptionSelection();
                    }
                    else {
                        this._dataList.clearItemSelection();
                    }
                };
                this._showFilter = () => {
                    this._log.info("FormListWidgetInstanceClass._showFilter()");
                    this._core.Functions.hideElement(this._showFilterSpan);
                    this._core.Functions.showElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._filterPanel);
                    this._filterText.focus();
                };
                this._hideFilter = () => {
                    this._log.info("FormListWidgetInstanceClass._hideFilter()");
                    this._core.Functions.hideElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._showFilterSpan);
                    this._core.Functions.hideElement(this._filterPanel);
                    this._clearFilter();
                };
                this._clearFilter = () => {
                    this._log.info("FormListWidgetInstanceClass._clearFilter()");
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._doFilter = () => {
                    this._log.info("FormListWidgetInstanceClass._doFilter()");
                    let filterText = this._filterText.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("filtering with: " + filterText);
                    }
                    if (this._presentAsButtons) {
                        this._buttonPalette.filterOptions(filterText);
                    }
                    else {
                        this._dataList.filterItems(filterText);
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("FormListWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = config;
                this._buttonsVertical = true;
                if (conf.hasOwnProperty('Type') && conf.Type === 'Buttons') {
                    this._presentAsButtons = true;
                    if (conf.hasOwnProperty('ButtonsVertical') && !conf.ButtonsVertical) {
                        this._buttonsVertical = false;
                    }
                }
                else {
                    this._presentAsButtons = false;
                }
            }
        }
        FormListWidgetInstanceClass.HtmlData = null;
        Widgets.FormListWidgetInstanceClass = FormListWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
